// Index files serve as entry points for importing and exporting functions and classes only. They should not contain any application logic or implementation details.

import collection from './collection';

function index() {
  collection();
}

export default index;
